import { checkProviderRole } from "@/auth/utils";

export default [
  {
    path: "/proveedor/formularios",
    name: "provider-forms",
    component: () =>
      import("@/views/modules/provider/forms/forms-list/FormsList.vue"),
    beforeEnter: checkProviderRole,
    meta: {
      resource: "ACL",
      pageTitle: "Formularios",
      breadcrumb: [
        {
          text: "Lista de formularios",
          active: true,
        },
      ],
      requiresAuth: true,
    },
  },
];
